import { render, staticRenderFns } from "./waybill.vue?vue&type=template&id=2fc04c74&scoped=true"
import script from "./waybill.vue?vue&type=script&lang=js"
export * from "./waybill.vue?vue&type=script&lang=js"
import style0 from "./waybill.vue?vue&type=style&index=0&id=2fc04c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc04c74",
  null
  
)

export default component.exports